module.exports = __webpack_public_path__ + "img/9788995574775.ddb88d1a.jpg";